import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=494cf1a0"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports